import React, { useState } from 'react'
import cn from 'classnames'
import Button from '../components/Button'
import VNConcessionsNavBar from '../components/VNConcessionsNavBar'
import { setRoute } from '../VNRoutes/ActionCreators'
import { useDispatch, useSelector } from 'react-redux'
import VNBlueSwitch from '../components/VNBlueSwitch'
import styles from './RevenueCenterSetup.module.scss'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { setReceiptSettings } from '../actions/config'
import { getReceiptSettings } from '../selectors/config'

const PrinterSettingsConfig = ({ className }) => {
  const classNames = cn(styles.revenueCenterSetup, className)

  const history = useHistory()
  const dispatch = useDispatch()
  const isMobileViewPort = useGetIsMobileScreen()

  const receiptSettings = useSelector((state) => getReceiptSettings(state))

  const [autoPrintReceipt, setAutoPrintReceipt] = useState(receiptSettings?.autoPrintReceipt || false)
  const [print2CopiesEnabled, setPrint2CopiesEnabled] = useState(receiptSettings?.print2CopiesEnabled || false)

  const storeSelection = () => {
    dispatch(setReceiptSettings({ autoPrintReceipt, print2CopiesEnabled }))
  }

  const goBack = () => {
    storeSelection()
    dispatch(setRoute('/revenue-center-setup', { fromPrinterSettings: true }))
  }

  const handleDone = () => {
    storeSelection()
    history.replace({
      pathname: '/barcode-scanning-settings-config',
    })
  }

  const RenderPrintSettings = ({ disabled, name, onClick, isChecked }) => {
    return (
      <div className={styles.record}>
        <div className={styles.menuDetails} style={{ width: '100%', justifyContent: 'space-between' }}>
          <div className={styles.svgIconContainer} style={{ width: '100%', justifyContent: 'left' }}>
            {name}
          </div>
          <div className={styles.svgIconContainer}>
            <VNBlueSwitch disabled={disabled} onClick={onClick} checked={isChecked} />
          </div>
        </div>
      </div>
    )
  }

  const onAutoPrintReceiptChange = () => {
    if (autoPrintReceipt) {
      setPrint2CopiesEnabled(false)
    }
    setAutoPrintReceipt(!autoPrintReceipt)
  }

  return (
    <div>
      <div className={classNames}>
        <VNConcessionsNavBar
          textDisplay={isMobileViewPort && 'Receipt Printer Settings'}
          useSmallTitleFont={true}
          useHamburgerIcon={true}
        />
        {!isMobileViewPort && <div className={styles.header}>Receipt Printer Settings</div>}
        <div className={styles.container}>
          <div className={styles.container}>
            <div className={styles.standMenus}>
              <RenderPrintSettings name="Auto-Print Receipt" onClick={onAutoPrintReceiptChange} isChecked={autoPrintReceipt} />
              <RenderPrintSettings
                disabled={!autoPrintReceipt}
                name="Print 2 Copies"
                onClick={() => setPrint2CopiesEnabled(!print2CopiesEnabled)}
                isChecked={print2CopiesEnabled}
              />
            </div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button useMui className={styles.backButton} onClick={goBack}>
            Back
          </Button>
          <Button useMui className={styles.doneButton} onClick={() => handleDone()}>
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}

export default PrinterSettingsConfig
